import React from 'react';
import styled from 'styled-components';

const GridRow = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto auto;
  margin-left: ${props => props.theme.grid.negGutterWidth};
  margin-right: ${props => props.theme.grid.negGutterWidth};
`;

export default GridRow;
